module.exports = __webpack_public_path__ + "static/media/chevronRight.49dcf410.svg";